<template>
  <div class="box16">
    <div class="left">
      <div class="title">架构师学习路线图</div>
      <div class="tag-box">
        <div class="tag">科学</div>
        <div class="tag">全面</div>
        <div class="tag">实用</div>
      </div>
      <div class="btn" @click="zixun('免费领取')">免费领取</div>
    </div>
    <div class="right"></div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {};
  },

  mounted() {},
  methods: {
    zixun(e) {
      this.mai("狂野架构师-职场进阶课","免费领取",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box16 {
  position: relative;
  padding-top: 26px;
  padding-left: 50px;
  width: 100%;
  height: 230px;
  background: url("../../../assets/coursePage/architect/box15/bg.png") no-repeat;
  background-size: cover;
  background-position-x: center;
  box-sizing: border-box;

  .left {
    .title {
      margin-bottom: 8px;
      font-family: PingFangSC-Semibold;
      font-size: 40px;
      font-weight: bold;
      color: #fafbff;
    }
    .tag-box {
      display: flex;
      align-items: center;
      .tag {
        margin-right: 18px;
        width: 92px;
        height: 40px;
        background-color: rgba(255, 255, 255, 0.3);
        border-radius: 20px;
        text-align: center;
        font-family: PingFang SC;
        font-size: 24px;
        font-weight: normal;
        line-height: 40px;
        color: #ffffff;
      }
    }

    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 25px;
      width: 150px;
      height: 46px;
      background-color: #ffffff;
      border-radius: 10px;
      text-align: center;
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      font-weight: bold;

      letter-spacing: 1px;
      color: #006aff;
    }
  }

  .right {
    position: absolute;
    right: 0px;
    bottom: 0px;
    width: 235px;
    height: 268px;
    background: url("../../../assets/coursePage/architect/box15/icon.png")
      no-repeat;
    background-size: cover;
  }
}
</style>
